import { Component } from '@angular/core';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-no-results',
    templateUrl: './no-results.component.html',
    styleUrls: ['./no-results.component.scss'],
    standalone: false
})
export class NoResultsComponent {
  totalResults: number | undefined;
  hideNoResults: boolean;
  translations:any

  constructor(private translationservice:TranslationService) {
    this.hideNoResults = true;
  }

  ngOnInit()
  {
    this.translationservice.getTranslation().subscribe(data => {
      this.translations = data;
    })
  }

  setTotal(total: number): void {
    this.totalResults = total;
    this.hideNoResults = this.totalResults != undefined && this.totalResults > 0;
  }
}
